import { isFeatureEnabled } from '@lumapps/features';

import { USER_PROFILE_REACT_FEATURE_TOKEN } from '../constants';

/**
 * Selector to see if the user space FF is enabled.
 */
export const isUserProfileReactEnabled = isFeatureEnabled(USER_PROFILE_REACT_FEATURE_TOKEN);
